import { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Drawer } from "antd";
import Button from "../Reusables/Button/Button";
import FilterIcon from "../../assets/icons/filter.svg";
import Wrapper from "../FilterDrawer/Wrapper";
import Header from "../FilterDrawer/Header";
import { setIsDrawerOpen } from "../../store/inventorySlice";
import "../../assets/css/Map/map.css";

const FilterButton = () => {
  const dispatch = useDispatch();
  const {
    isDrawerOpen,
    items: { blocks, racks },
  } = useSelector((state) => state.inventory);

  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    if (blocks.length && racks.length) {
      setDisabled(false);
    }
  }, [blocks, racks]);

  const [drawerWidth, setDrawerWidth] = useState(400);

  useEffect(() => {
    const updateWidth = () =>
      window.innerWidth > 2000 ? setDrawerWidth(700) : setDrawerWidth(400);
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  return (
    <div className="filter-btn-container">
      <Button
        onClick={() => dispatch(setIsDrawerOpen(true))}
        placeholder="Filter"
        btnClass="legend-btn"
        icon={FilterIcon}
        disabled={disabled}
        disabledBtnClass="filter-btn-disable"
      />
      <Drawer
        title={<Header onClose={() => dispatch(setIsDrawerOpen(false))} />}
        open={isDrawerOpen}
        onClose={() => dispatch(setIsDrawerOpen(false))}
        closable={false}
        zIndex={1500}
        style={{ backgroundColor: "#F1F3F5" }}
        width={drawerWidth}
      >
        <Wrapper />
      </Drawer>
    </div>
  );
};

export default memo(FilterButton);
